import React from "react";

import "./styles.css";

const EmptyStateCard = ({ icon, title, body, actions, inline = false, children }) => (
  <div className="sy-empty-wrap">
    <div className={inline ? "sy-empty-card sy-empty-card-inline" : "sy-empty-card"}>
      {icon && (
        <span className="sy-empty-card-mark" aria-hidden="true">
          {icon}
        </span>
      )}

      <h2 className="sy-empty-card-title">{title}</h2>
      {body && <p className="sy-empty-card-body">{body}</p>}
      {actions && <div className="sy-empty-card-actions">{actions}</div>}

      {children}
    </div>
  </div>
);

export default EmptyStateCard;
